import React,{Component,Fragment} from 'react';
import './Navbar.css';
import {Link} from 'react-router-dom';
import logoblue from '../../../../image/logoblue.png'

class Navbar extends Component{
    render(){
        const url =window.location.pathname.split('/').slice(2).toString().replace(',', '/')

        return(
            <div>
                <nav className="navbar navbar-expand-lg color-md fixed-top  colornav" >
                        <div className="container">
                        <Link to="/AR/"><img className="logo" src={logoblue} alt="kayn"/></Link>       

                                 <button className="navbar-toggler navbar-dark " type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className="collapse navbar-collapse List" id="navbarNav">
                                <ul className="navbar-nav ml-auto text-uppercase">
                                    <li className="nav-item active">
                                        <Link className="nav-link" to="/AR/#Feautures">المميّزات<span className="sr-only">(current)</span></Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/AR/#Howitwork">آليّات العمل</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/AR/#Reviews">التعليقات</Link>
                                    </li>
                                    {(localStorage.getItem("userToken")?
                                    <Fragment>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/AR/Orders">الطلابات</Link>
                                    </li>
                                    <li className="nav-item">
                                    <Link className="nav-link" to={"/"+url}>EN</Link>
                                    </li>
                                    </Fragment>
                                    :(localStorage.getItem("AdminTokenKayn")?
                                    <Fragment>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/Admin/Orders">الطلبات</Link>
                                    </li>
                                    <li className="nav-item">
                                    <Link className="nav-link" to={"/"+url}>EN</Link>
                                    </li>
                                    </Fragment>
                                     :
                                     <Fragment>
                                     <li className="nav-item">
                                     <Link className="nav-link" to="/AR/SignUp">تسجيل</Link>
                                     </li>
                                     <li className="nav-item">
                                     <Link className="nav-link" to="/AR/SignIn">دخول</Link>
                                     </li>
                                     <li className="nav-item">
                                     <Link className="nav-link" to={"/"+url}>EN</Link>
                                     </li>
                                     </Fragment>))}
                                </ul>
                            </div>
                        </div>
                    </nav>
               
            </div>
        )
    }
}
export default Navbar;